import { Component, Input, OnInit } from '@angular/core';
import { LoaderService } from "../../../core/services/loader.service";
@Component({
  selector: 'app-loader2',
  templateUrl: './loader2.component.html',
  styleUrls: ['./loader2.component.scss']
})
export class Loader2Component implements OnInit{
  @Input() airlinesFetched;


  constructor(private loaderService: LoaderService){

  }

  ngOnInit(): void {
    
  }
}
